import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { AppService } from '@Core/services/proprietary/app.service';
import { DataService } from '@Core/services/proprietary/data.service';
import { DataSourceStatus } from '@Core/services/proprietary/datasource';
import { cloneDeep } from 'src/ep-utils';
import { PrepareRequest, ResetState, SetProjectObjectState, UpdateProject } from './project-object.actions';
import { denormalize, normalize, rootSchema } from './project-object.normalize';
import { ProjectObjectState } from './project-object.state';
import { EventType } from './project-object.types';

@Injectable()
export class ProjectObjectService implements OnDestroy {
    dataService: DataService;

    private dsProcessStatusSub: Subscription;
    private dsGetStatusSub: Subscription;
    //private dsDocumentAssemblerProcessStatusSub: Subscription;

    private pageID: any = null;
    private projectID: any = null;

    // private sendDocumentsCallback: any = null;
    //private rootRoute: string; // root page to return to on exit project

    constructor(private store: Store, private app: AppService) { }

    /* get isProjectActive(): boolean {
      return this.projectID != null;
    } */

    get currentProjectID(): boolean {
        return this.projectID;
    }

    ngOnDestroy() {
        if (this.dsGetStatusSub) {
            this.dsGetStatusSub.unsubscribe();
        }
        if (this.dsProcessStatusSub) {
            this.dsProcessStatusSub.unsubscribe();
        }
    }

    load(pageID: any) {
        this.pageID = pageID;

        let projectID = this.app.pageParams.getParameter(pageID, 'Project_ID');
        this.loadObject(projectID);
    }

    loadObject(id: any) {
        this.projectID = id;

        this.app.dsProjectGet.reset(); //clear process datastore (resets error messages)
        if (this.app.dsProjectProcess.error == true) {
            this.app.dsProjectProcess.reset(); //clear process datastore (resets error messages)
        }

        let criteria: any = { View: 'Standard', json: 'CT2', Reference_Options: 'Desc;Entity_Name.All' };

        criteria.Project_ID = id;

        this.app.dsProjectGet.get(criteria, true, false);
        this.dsGetStatusSub = this.app.dsProjectGet.status$.subscribe((x) => {
            this.dsGetStatusUpdated(x);
        });
    }

    loadData(data: any) {
        if (this.app.dsProjectProcess.error == true) {
            this.app.dsProjectProcess.reset(); //clear process datastore (resets error messages)
        }
        let normalizedData = normalize(data, rootSchema);
        this.store.dispatch(new SetProjectObjectState(normalizedData.entities));
        //this.taskOS.setProjectState(this.app.dsProjectGet.objectNode);
    }

    dsGetStatusUpdated(status: DataSourceStatus) {
        switch (status) {
            case DataSourceStatus.Ready:
                if (this.dsGetStatusSub) {
                    this.dsGetStatusSub.unsubscribe();
                }
                this.loadData(this.app.dsProjectGet.data);

                break;
            case DataSourceStatus.Error:
                if (this.dsGetStatusSub) {
                    this.dsGetStatusSub.unsubscribe();
                }
                break;
        }
    }

    resetState() {
        this.projectID = null;
        this.store.dispatch(new ResetState());
    }

    updateProject(project: any) {
        this.store.dispatch(new UpdateProject(project));
    }

    process(event: EventType | EventType[], tranOptions: any = {}) {
        let eventStr: string = null;

        if (Array.isArray(event)) {
            let events: EventType[] = event;
            events.forEach(function (item) {
                eventStr = eventStr ? (eventStr = eventStr + ';' + item) : item;
            });
        } else {
            eventStr = event;
        }

        this.store
            .dispatch(new PrepareRequest({ Event: eventStr, ...tranOptions }))
            .subscribe((action) => this.finishProcess());
    }

    finishProcess() {
        let stateEntities = this.store.selectSnapshot(ProjectObjectState.entities);

        stateEntities = cloneDeep(stateEntities);

        let tran = denormalize('1', rootSchema, stateEntities);

        this.app.dsProjectProcess.process({ json: 'CT2' }, tran);
        this.dsProcessStatusSub = this.app.dsProjectProcess.status$.subscribe((x) => {
            this.processStatusUpdated(x);
        });
    }

    processStatusUpdated(status: DataSourceStatus) {
        switch (status) {
            case DataSourceStatus.Ready:
                this.dsProcessStatusSub.unsubscribe();
                this.loadObject(this.projectID);
                break;
            case DataSourceStatus.Error:
                this.dsProcessStatusSub.unsubscribe();
                if (this.projectID) {
                    this.loadData(this.app.dsProjectGet.data); //reload old data
                }
                break;
        }
    }

    /* openProjectTracker() {
      this.router.navigate([
        'project-tracker',
        { Project_ID: this.projectID, Selected_Task_ID: this.taskOS.currentTaskID }
      ]);
    } */

    /* openProjectTrackerByProjectID(projectID?: any) {
      if (projectID) {
        this.resetState();
        this.taskOS.suppressTaskHeader(true);
        this.projectID = projectID;
        this.router.navigate(['project-tracker', { Project_ID: projectID }]);
      }
    } */

    /*  setRootRoute(route: string) {
      this.rootRoute = route;
    } */

    /* exitProject(autoNavigate: boolean = true) {
      this.projectID = null;
      this.taskOS.suppressTaskHeader(true);
      this.resetState();
      if (autoNavigate) {
        if (!this.rootRoute || this.rootRoute === '') {
          this.rootRoute = '/my-work';
        }
        this.router.navigateByUrl(this.rootRoute);
      }
    } */

    /* closeProject() {
      let body = {
        ConceptOneRequest: {
          SDK_Version: this.app.dsSystemInfo.data.ConceptOneReply.SDK_Version,
          ProjectProcess: {
            Event: 'Close',
            Project: {
              Project_ID: this.projectID
            }
          }
        }
      };
  
      this.dsProcessStatusSub = this.app.dsProjectProcess.status$.subscribe((x) => {
        if (x == DataSourceStatus.Ready) {
          this.projectCloseSuccessful();
        }
        if (x == DataSourceStatus.Error) {
          this.projectCloseFailed();
        }
      });
      this.app.dsProjectProcess.process({}, body);
    } */

    /* private projectCloseSuccessful() {
      this.dsProcessStatusSub.unsubscribe();
      this.resetState();
      this.router.navigate(['my-work', {}]);
    } */

    /* private projectCloseFailed() {
      this.dsProcessStatusSub.unsubscribe();
    } */
}
